import { dispatch } from 'redux';
import PrivateAPIResource from '../services/PrivateAPIResource';
import * as types from './actionTypes';

// actions
export function loadCertificatesSuccess(certificates) {
    return {type: types.LOAD_CERTIFICATES_SUCCESS, all: certificates};
}

export function initializeSelectedCertificates(certificates) {
    return {type: types.INIT_SELECTED_CERTIFICATES, certificates};
}

export function selectTheCertificate(id) {
    return {type: types.SELECT_THE_CERTIFICATE, certificateId: id};
}

export function deselectTheCertificate(id) {
    return {type: types.DESELECT_THE_CERTIFICATE, certificateId: id};
}

export function updateCertificates () {
    return {type: types.UPDATE_THE_CERTIFICATES};
}

// action creators
export function loadCertificates() {
    return async (dispatch, getState) => {
        try {
            const companyId = getState().user.company.id;

            const requests = [
                PrivateAPIResource.all('certificates'),
                PrivateAPIResource.all(`certifications/${companyId}`)
            ];

            const responses = await Promise.all(requests);

            const certificates = responses.shift();
            const selectedCertificates = responses.shift();

            dispatch(initializeSelectedCertificates(selectedCertificates));
            dispatch(loadCertificatesSuccess(certificates));

        } catch (err) {
            // @TODO handle loadCertificatesFail
            throw err;
        }
    }
}

export function filterCertificates(query) {
    return {type: types.FILTER_CERTIFICATES, query};
}

export function dispatchSelectionInit(certificates) {
    return (dispatch) => {
        dispatch(initializeSelectedCertificates(certificates));
    }
}

export function dispatchChangingTheCertificate(id) {
    return (dispatch, getState) => {

        getState().certificates.selected.indexOf(id) === -1 ?
            dispatch(selectTheCertificate(id)) :
            dispatch(deselectTheCertificate(id));
    }
}

export function dispatchUpdateCertificates() {
    return async (dispatch, getState) => {

        const promise = PrivateAPIResource.update(
            `certifications`,
            getState().user.company.id,
            { certificateIds: getState().certificates.selected }
        );

        dispatch(updateCertificates());

        return promise;
    }
}

export function dispatchFiltering(query) {
    return (dispatch) => {
        dispatch(filterCertificates(query));
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/certificateActions.js